import { requestServices } from 'repos';
import { getResult } from 'helpers/request';
import {
  ILockMerchantParams,
  IMerchantCreate,
} from '../../interfaces/merchant';
import { bffServiceClient } from '../../packages/request/clients';

const { locationService } = requestServices;

/**
 * search merchants
 * @param {object} params
 * @returns {Promise<AxiosResponse<T>>}
 */
const findAll = (params: object) => {
  return bffServiceClient
    .get('/merchant', {
      params,
    })
    .then(getResult);
};

/**
 * find merchant by id
 * @param {object} params
 * @returns {Promise<AxiosResponse<T>>}
 */
const findById = (merchantId: number) => {
  return locationService.get(`/merchants/${merchantId}`).then(getResult);
};

const lockOrUnlock = (params: ILockMerchantParams) => {
  return bffServiceClient
    .post(`/merchants/${params.merchant_id}/update_status`, params)
    .then(getResult);
};

const createMerchant = (params: IMerchantCreate) => {
  return bffServiceClient.post(`/merchant`, params).then(getResult);
};

const updateMerchant = (merchantId: number, params: any) => {
  return bffServiceClient.post(`/merchant`, params).then(getResult);
};

const updateMerchantApprovalStatus = (
  merchantId: number,
  status: string,
  note: string
) => {
  return bffServiceClient
    .put(`/merchants/change-approval-status/${merchantId}/`, {
      status: status,
      note: note,
    })
    .then(getResult);
};

export default {
  findAll,
  findById,
  lockOrUnlock,
  createMerchant,
  updateMerchant,
  updateMerchantApprovalStatus,
};
